<template>
  <b-modal id="addUser" size="lg" :title="$t('users.add_title')" ref="modalAddUser" @ok="handleStore" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
      <div class="form-group">
        <label for="storelogin" class="col-form-label">{{ $t('users.login') }}</label>
        <input type="text" class="form-control" v-model="user.login" id="storelogin" :class="{'is-invalid': errors.login }" placeholder="Логин">
        <span v-if="errors.login" class="invalid-feedback">
            <strong>{{ errors.login ? errors.login[0] : '' }}</strong>
        </span>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="storefullname" class="col-form-label">{{ $t('users.fullname') }}</label>
          <input type="text" class="form-control" v-model="user.fullname" id="storefullname" :class="{'is-invalid': errors.fullname }" placeholder="ФИО">
          <span v-if="errors.fullname" class="invalid-feedback">
              <strong>{{ errors.fullname ? errors.fullname[0] : '' }}</strong>
          </span>
        </div>
      </div>
      <!-- <div class="row">
        <div class="form-group col-md-4">
          <label for="storefirstname" class="col-form-label">{{ $t('debtors.lastname') }}</label>
          <input type="text" class="form-control" v-model="user.lastname" id="storelastname" :class="{'is-invalid': errors.lastname }" placeholder="Фамилия">
          <span v-if="errors.lastname" class="invalid-feedback">
              <strong>{{ errors.lastname ? errors.lastname[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group col-md-4">
          <label for="storefirstname" class="col-form-label">{{ $t('debtors.firstname') }}</label>
          <input type="text" class="form-control" v-model="user.firstname" id="storefirstname" :class="{'is-invalid': errors.firstname }" placeholder="Имя">
          <span v-if="errors.firstname" class="invalid-feedback">
              <strong>{{ errors.firstname ? errors.firstname[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group col-md-4">
          <label for="storefirstname" class="col-form-label">{{ $t('debtors.middlename') }}</label>
          <input type="text" class="form-control" v-model="user.middlename" id="storemiddlename" :class="{'is-invalid': errors.middlename }" placeholder="Отчества">
          <span v-if="errors.middlename" class="invalid-feedback">
              <strong>{{ errors.middlename ? errors.middlename[0] : '' }}</strong>
          </span>
        </div>
      </div> -->
      <div class="row">
        <div class="form-group col-md-6">
          <label for="storeemail" class="col-form-label">{{ $t('users.email') }}</label>
          <input type="text" class="form-control" v-model="user.email" id="storeemail" :class="{'is-invalid': errors.email }" placeholder="E-mail">
          <span v-if="errors.email" class="invalid-feedback">
              <strong>{{ errors.email ? errors.email[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group col-md-6">
          <label for="storephone" class="col-form-label">{{ $t('users.phone') }}</label>
          <input type="text" class="form-control" v-model="user.phone" id="storephone" :class="{'is-invalid': errors.phone }" placeholder="Телефон">
          <span v-if="errors.phone" class="invalid-feedback">
              <strong>{{ errors.phone ? errors.phone[0] : '' }}</strong>
          </span>
        </div>
      </div>
      <div class="form-group">
          <label>{{ $t('users.role') }}</label>
          <select class="form-control" v-model="user.role" :class="{'is-invalid': errors.role }">
            <option v-for="role in adminListRoles" :value="role.id">
              {{ role.display_name }}
            </option>
          </select>
          <span v-if="errors.role" class="invalid-feedback">
              <strong>{{ errors.role ? errors.role[0] : '' }}</strong>
          </span>
      </div>
      <div class="form-group">
        <label for="storefirstname" class="col-form-label">
          {{ $t('users.password') }}
          <button type="button" class="btn btn-link" @click="switchVisiblityPass">
            <i class="fa fa-eye fa-lg" aria-hidden="true" v-if="this.passwordFieldType === 'password'"></i>
            <i class="fa fa-eye-slash fa-lg" aria-hidden="true" v-if="this.passwordFieldType === 'text'"></i>
          </button>
        </label>
        <input :type="passwordFieldType" class="form-control" v-model="user.password" id="storepassword" :class="{'is-invalid': errors.password }" placeholder="Пароль">
        <span v-if="errors.password" class="invalid-feedback">
            <strong>{{ errors.password ? errors.password[0] : '' }}</strong>
        </span>
      </div>
      <div class="form-group">
        <label for="storefirstname" class="col-form-label">{{ $t('users.confirm_password') }}</label>
        <input :type="passwordFieldType" class="form-control" v-model="user.password_confirmation" id="storepassword_confirmation" :class="{'is-invalid': errors.password_confirmation }" placeholder="Подтвердите пароль">
        <span v-if="errors.password_confirmation" class="invalid-feedback">
            <strong>{{ errors.password_confirmation ? errors.password_confirmation[0] : '' }}</strong>
        </span>
      </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data(){
    return {
      user: {
        fullname: null,
        password: null,
        email: null,
        phone: null,
        password_confirmation: null,
        login: null,
        role: null,
      },
      passwordFieldType: 'password',
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminListRoles',
    ]),
  },
  mounted() {
    this.GET_ADMIN_LIST_ROLES()
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_ROLES',
    ]),
    clearModalUser() {
      this.user.fullname = '';
      this.user.password = '';
      this.user.email = '';
      this.user.phone = '';
      this.user.password_confirmation = '';
      this.user.login = '';
    },
    switchVisiblityPass() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeUser();
    },

    storeUser() {
      this.isProcessing = true;
      axios.post('/admin/users', this.user)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddUser.hide();
            Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearModalUser();
            this.$emit('fetchUsers');
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
